export default {
  'pages.trafficstars.loadFailed': '加载失败',
  'pages.trafficstars.saveSuccess': '保存成功',
  'pages.trafficstars.saveFailed': '保存失败',
  'pages.trafficstars.editTitle': '编辑 TrafficStars S2S',
  'pages.trafficstars.createTitle': '新建 TrafficStars S2S',
  'pages.trafficstars.back': '返回列表',
  'pages.trafficstars.loadError': '加载失败，请刷新后重试。',
  'pages.trafficstars.name': '配置名称',
  'pages.trafficstars.nameRequired': '请输入配置名称',
  'pages.trafficstars.namePlaceholder': '例如：体育单页按钮点击',
  'pages.trafficstars.landingPage': '关联落地页',
  'pages.trafficstars.pageRequired': '请选择落地页',
  'pages.trafficstars.pagePlaceholder': '选择普通落地页或 AI 落地页',
  'pages.trafficstars.standardPage': '普通',
  'pages.trafficstars.key': '回传密钥（key）',
  'pages.trafficstars.keyRequired': '请输入回传密钥',
  'pages.trafficstars.keyEditHelp': '密钥不会回显，留空保留原密钥。',
  'pages.trafficstars.keyHelp':
    'TrafficStars 后台生成的 S2S 回传配置中，复制 key 填写.',
  'pages.trafficstars.keyEditPlaceholder': '留空保留原密钥',
  'pages.trafficstars.keyPlaceholder': '输入 key 的值，无需填写完整地址',
  'pages.trafficstars.goalOptional': '目标 ID（goalid，选填）',
  'pages.trafficstars.goalInvalid': '目标 ID 只能填写数字',
  'pages.trafficstars.goalPlaceholder': '例如：5714',
  'pages.trafficstars.valueOptional': '转化收入（value，选填）',
  'pages.trafficstars.priceOptional': '转化成本（price，选填）',
  'pages.trafficstars.amountPlaceholder': '例如：0.50',
  'pages.trafficstars.amountHelp': '每次回传使用此金额，留空不传。',
  'pages.trafficstars.amountInvalid': '请输入大于或等于 0 的数字',
  'pages.trafficstars.error.invalidValue':
    'value 必须是大于或等于 0 的数字，不能填写占位符',
  'pages.trafficstars.error.invalidPrice':
    'price 必须是大于或等于 0 的数字，不能填写占位符',
  'pages.trafficstars.remark': '备注',
  'pages.trafficstars.active': '启用回传',
  'pages.trafficstars.allowDuplicates': '允许重复',
  'pages.trafficstars.save': '保存配置',
  'pages.trafficstars.requestSuccess': '回传请求成功',
  'pages.trafficstars.retryStillFailed': '回传仍失败，请查看响应详情',
  'pages.trafficstars.retryFailed': '重试失败',
  'pages.trafficstars.time': '时间',
  'pages.trafficstars.goalId': '目标 ID',
  'pages.trafficstars.defaultLead': '默认 Lead',
  'pages.trafficstars.button': '按钮',
  'pages.trafficstars.status': '状态',
  'pages.trafficstars.success': '请求成功',
  'pages.trafficstars.failed': '失败',
  'pages.trafficstars.pending': '处理中',
  'pages.trafficstars.attempts': '尝试次数',
  'pages.trafficstars.actions': '操作',
  'pages.trafficstars.details': '详情',
  'pages.trafficstars.retryTitle': '重试这条回传？',
  'pages.trafficstars.retryHelp':
    '使用原 Click ID 和 lead_code 重试，是否重复计数由 TrafficStars 判断。处理中记录需等待一分钟。',
  'pages.trafficstars.retry': '重试',
  'pages.trafficstars.statsTitle': 'TrafficStars 回传记录',
  'pages.trafficstars.attributionHelp':
    '请求成功表示接口返回成功响应；最终是否归因，请以 TrafficStars 后台统计及 S2S Test 为准。',
  'pages.trafficstars.allStatuses': '全部状态',
  'pages.trafficstars.detailTitle': '回传详情',
  'pages.trafficstars.pageUrl': '落地页',
  'pages.trafficstars.response': '响应 / 错误',
  'pages.trafficstars.emptyResponse': '无响应正文',
  'pages.trafficstars.identifier': '标识',
  'pages.trafficstars.buttonClick': '按钮点击',
  'pages.trafficstars.listSubtitle':
    '监控落地页按钮点击，自动回传 TrafficStars 转化',
  'pages.trafficstars.listHeader': '回传配置列表',
  'pages.trafficstars.copyFailed': '复制失败',
  'pages.trafficstars.error.notFound': 'TrafficStars 配置不存在或无权限',
  'pages.trafficstars.error.invalidKey': 'Postback 缺少有效的 key',
  'pages.trafficstars.error.missingKey': '请输入 TrafficStars 回传密钥（key）',
  'pages.trafficstars.error.invalidGoal':
    'goalid 必须是后台目标的数字 ID，不能是占位符',
  'pages.trafficstars.error.inactive': '配置已停用',
  'pages.trafficstars.error.recordMissing': '回传记录不存在',
  'pages.trafficstars.error.notRetryable':
    '该记录已成功或正在回传，请勿重复提交',
};
